$(document).ready(function(){
  if($('.block__shop-by-category--slider').length){
    $(".block__shop-by-category").removeClass("hide");
    $('.block__shop-by-category--slider').slick({
      slidesToShow: 8,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      draggable: false,
      dots: false,
      responsive: [
        {
          breakpoint: 1441,
          settings: {
            slidesToShow: 6
          }
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 4
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 2
          }
        },
        ,
        {
          breakpoint: 375,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
  }
});